import type { FormConfig } from '@workspace/core-ts/types';

/**
 * Configuration spécifique pour le formulaire Livraison
 *
 * Cette configuration permet de contrôler l'affichage et le comportement
 * des différents éléments de l'interface du formulaire.
 */
export const livraisonFormConfig: FormConfig = {
  header: {
    showBackButton: true,
    showLogo: true,
    showPhoneButton: true,
    showStepper: true,
    phoneNumber: '04 49 02 37 19',
  },
  footer: {
    showBanner: true,
    showLinks: true,
  },
  layout: {
    animationType: 'fade',
  },
  features: {
    enableModalRappeler: true,
    enableAutoSave: true,
    enableAnalytics: true,
  },
  modalRappeler: {
    consentLabel:
      "Afin d'être accompagné dans le cadre de ma démarche d'assurance, j'accepte qu’un expert moto me contacte par téléphone.",
  },
};

// Export par défaut pour faciliter l'import
export default livraisonFormConfig;
